import React, { useState } from 'react';
import { Product } from '../../types/product';
import { useCart } from '../../context/CartContext';
import { DynamicTeaOptionsModal } from '../modals';
import { getProductImage } from '../../utils/productUtils';
import { useAuth } from '../../context/AuthContext';

const TeaCard: React.FC<{ product: Product }> = ({ product }) => {
  const { addToCart } = useCart();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { isAuthenticated } = useAuth();
  // Fiyatı küsuratsız ve "fiş" olarak göster
  const displayPrice = `${parseInt(product.price as any, 10)} fiş`;

  const handleAddToCart = (options: {
    quantity: number;
    selectedOptions: Record<string, string>;
  }) => {
    addToCart(
      {
        ...product,
        dynamicOptions: options.selectedOptions, // Yeni format
      },
      options.quantity
    );
    // Modal'ı burada kapatmıyoruz - DynamicTeaOptionsModal kendi başarı ekranını gösterecek
  };

  return (
    <div className="bg-white rounded-2xl shadow-lg overflow-hidden relative min-h-[306px] flex flex-col">
      <div className="relative">
        <div className="flex items-center justify-center bg-gradient-to-b from-yellow-50 to-orange-100 h-44">
          {/* Görsel alanı için image_url veya getProductImage kullanılabilir */}
          {product.image_url ? (
            <img
              src={product.image_url}
              alt={product.name}
              className="w-full h-36 object-contain"
            />
          ) : (
            getProductImage(product.main_category_id, product.category_id)
          )}
        </div>
        <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-2 py-1 rounded-full text-sm font-medium text-gray-700">
          {displayPrice}
        </div>
        {isModalOpen && isAuthenticated && (
          <button
            onClick={() => setIsModalOpen(false)}
            className="absolute top-4 right-4 z-30 w-8 h-8 flex items-center justify-center rounded-full bg-gray-50 hover:bg-gray-200 text-gray-400 hover:text-gray-600 transition shadow"
            aria-label="Kapat"
            type="button"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="currentColor"
              className="w-5 h-5"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        )}
      </div>
      <div className="p-4 flex flex-col flex-1">
        <h3 className="text-lg font-semibold text-gray-900 mb-1">{product.name}</h3>
        <p className="text-sm text-gray-600 mb-3 line-clamp-3 overflow-hidden">
          {product.description}
        </p>
        {isAuthenticated && (
          <button
            onClick={() => setIsModalOpen(true)}
            className="w-full bg-gradient-to-r from-green-500 to-green-400 text-white py-2 rounded-xl font-medium shadow hover:from-green-600 hover:to-green-500 transition-all mt-auto"
          >
            Sepete Ekle
          </button>
        )}
      </div>
      {isModalOpen && isAuthenticated && (
        <div className="absolute inset-0 z-20 w-full h-full flex items-center justify-center bg-white/95 backdrop-blur-sm">
          <div className="w-full h-full flex items-center justify-center overflow-hidden">
            <DynamicTeaOptionsModal
              isOpen={isModalOpen}
              onClose={() => setIsModalOpen(false)}
              onConfirm={handleAddToCart}
              product={product}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default TeaCard;
